<script lang="ts">
	import { onMount } from 'svelte';
    // import { PUBLIC_UPLOAD_HOST } from '$env/static/public';
	import { MarkerTool } from '$lib/utils/editorjs/marker-test';
	import type { EditorContent } from '$lib/types/editor-content';
	// import { fetchWrapper } from '$lib/utils/fetch-wrapper';
    
    let { value = $bindable() } = $props<{ value?: EditorContent }>();

    let editor: any = $state(null);
    // const uploadHost = PUBLIC_UPLOAD_HOST;


    onMount(async () => {
        console.log('Mounting EditorJS...');
        try {
            const { default: EditorJS } = await import('@editorjs/editorjs');
            const { default: Header } = await import ('@editorjs/header'); 
            const { default: List } = await import ('@editorjs/list'); 
            const { default: Paragraph } = await import ('@editorjs/paragraph');
            const { default: CenteredTextBlock } = await import ('$lib/utils/editorjs/centered-text-block');
            // const { default: SimpleImage } = await import ('@editorjs/simple-image'); 
            const { default: ImageTool } = await import ('@editorjs/image'); 
            console.log('imported EditorJS and tools');

            const HeaderProxy: any = Header;
            const ImageToolProxy: any = ImageTool;
            const ParagraphProxy: any = Paragraph;
            ParagraphProxy.save = (blockContent:any) => {
                return {
                    text: blockContent.innerHTML
                }
            }
            editor = new EditorJS({ 
                holder: "editorjs",
                inlineToolbar: ['link', 'bold', 'italic'],
                data: value,
                tools: { 
                    // header: { 
                    //     class: HeaderProxy, 
                    //     config: {
                    //         placeholder: 'Wprowadź tytuł',
                    //         levels: [2, 3, 4],
                    //         defaultLevel: 2
                    //     }
                    // },
                    paragraph: {
                        class: ParagraphProxy,
                        inlineToolbar: [
                            // 'marker', 
                            'bold',
                            'link',
                            'italic',
                            // 'inlineCode'
                        ],  // enable bold/italic-like features
                        config: {
                            preserveBlank: true
                        },
                    },
                    centeredParagraph: {
                        class: CenteredTextBlock,
                        inlineToolbar: ['marker'],
                        config: {
                            placeholder: 'Start writing…',
                        },
                    },
                    marker: MarkerTool,            // works like highlight/italic
                    // inlineCode: InlineCode,    // code formatting
                    // list: List,
                    // image: {
                    //     class: ImageToolProxy,
                    //     config: {
                    //         uploader: {
                    //             uploadByFile(file: any) {
                    //                 console.log(file);

                    //                 return fetch('/admin/api/upload-image', {
                    //                     method: 'POST',
                    //                     // body: formData,
                    //                     body: file!,
                    //                     headers: {
                    //                         'Content-Type': file!.type,
                    //                         'X-Filename': file!.name,  //
                    //                     }
                    //                 })
                    //                 .then(response => response!.json())
                    //                 .then(d => { console.log(d); return d; })
                    //                 .then(data => ({
                    //                     success: 1,
                    //                     file: {
                    //                         url: data.file.url
                    //                     }
                    //                 }))
                    //                 .catch(() => ({
                    //                     success: 0
                    //                 }));
                    //             }
                    //         },
                    //         types: 'image/*', // Acceptable file types, use `image/*` to accept all image files
                    //         features: {
                    //             caption: 'optional'
                    //         },
                    //         captionPlaceholder: 'Dodaj podpis', // Placeholder for the caption
                    //         buttonContent: 'Wybierz obraz', // Custom button content
                    //     },
                    // },
                }, 
                onChange: async (api, event) => {
                    const data = (await editor.save());
                    value = (data);
                }
            });
        } catch (error) {
            console.error("Failed to load EditorJS:", error);
        }
    });
</script>

<div class="form-control">
    <div id="editorjs"></div>
</div>

<style>
    :global(.ce-block__content) {
        max-width: calc(100% - 2rem);
    }

    :global(.ce-toolbar__content) {
        max-width: calc(100% - 2rem);
    }

    :global(.ce-centered-paragraph) {
        text-align: center;
    }
</style>